// IMAGES

import Icon from "assets/Misc/roulette-pointer.svg";

const roulettePointer = Icon;

export { roulettePointer };
